import React from 'react';

import { Avatar } from '@mui/material';

const CrmMetricCard = ({ accent, helper, helperText, icon, label, value }) => (
    <div className='crm-dashboard-metric-card' style={{ '--metric-accent': accent, '--metric-helper': helper }}>
        <div className='crm-dashboard-metric-header'>
            <p className='crm-dashboard-eyebrow crm-dashboard-metric-label'>{label}</p>
            <Avatar className='crm-dashboard-metric-avatar'>{icon}</Avatar>
        </div>
        <h3 className='crm-dashboard-metric-value' title={value}>{value}</h3>
        <p className='crm-dashboard-metric-helper' title={helperText}>{helperText}</p>
    </div>
);

export default CrmMetricCard;
